module.exports = __webpack_public_path__ + "img/coming-soon.5850e03.webp";